import React from "react";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  CheckboxVisibility,
  TextField,
  PrimaryButton,
  DetailsRow,
  DialogType,
  DefaultButton,
  DetailsListLayoutMode,
} from "office-ui-fabric-react";
import InfiniteScroll from "react-infinite-scroller";
import axios from "axios";
import config from "../config";
import StatusBar from "./common/StatusBar";
import { LEAD_CATEGORY } from "../constants/enums";
import { VENDOR_COLUMNS } from "../constants/tableConfig";
import helpers from "../helpers";

export class Vendor extends React.Component {
  constructor(props) {
    super(props);
    this.limit = 100;
    this.rowRefs = {};
    this.state = {
      editingVendor: null,
      showDialogEdit: false,
      isNewVendor: false,
      isLoading: false,
      isUpdating: false,
      hasMore: true,
      showDialog: false,
      showDialogDelete: false,
      columns: VENDOR_COLUMNS(),
      vendors: [],
      filter: "all",
      searchText: "",
      total: 0,
      zipCodes: [],
      filterZipCodes: [],
      headerFilters: {},
      openHeaderFilters: false,
      errors: {},
    };

    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleValidateForm = this.handleValidateForm.bind(this);

  }

  componentDidMount() {
    this.fetch();

  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(
        _.get(prevProps, "location.pathname"),
        _.get(this.props, "location.pathname")
      ) ||
      !_.isEqual(
        _.get(prevProps, "location.search"),
        _.get(this.props, "location.search")
      )
    ) {
      this.setState(
        {
          vendors: [],
          hasMore: true,
        },
        () => {
          this.fetch(_.get(this.props, "searchBox"), 0);
        }
      );
    }
  }
  fetch(text, skip) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true,
    });
    var commonParams = {
      tag: window.location.search.replace("?tag=", ""),
      ...(this.state.isLGPage
        ? {
          process:
            this.state.filterLeadCategory || LEAD_CATEGORY.NOT_INTERESTED,
        }
        : {
          process:
            this.state.filter === LEAD_CATEGORY.ALL ? "" : this.state.filter,
        }),
      zipCodes: this.state.filterZipCodes.map((e) => e.key),
      filterSearch:
        text == undefined || text == null
          ? this.props.searchBox.filter || ""
          : text.filter,
      q:
        text == undefined || text == null
          ? this.props.searchBox.text || ""
          : text.text,
      filterLastName: this.state.headerFilters.lastName,
      filterAddress: this.state.headerFilters.address,
      filterCity: this.state.headerFilters.city,
      filterPhone: this.state.headerFilters.phone,
      filterStaff: this.state.headerFilters.staff,
      ...(this.state.isLGPage
        ? {
          isLGPage: true,
        }
        : {
          isInfoPage: true,
        }),
    };
    commonParams = {}
    axios
      .get(`${config.apiUrl}/organization/list`, {
        params: {
          ...commonParams,
          limit: this.limit,
          skip: skip != undefined ? skip : this.state.vendors.length,
          orgtype: "vendor"
        },
      })
      .then(({ data }) => {
        const duplicatedVendors = _.intersectionBy(
          data,
          this.state.vendors,
          "_id"
        );
        const newVendors = data.filter(
          (e) => !duplicatedVendors.some((c) => c._id === e._id)
        );
        const vendors =
          skip === 0 ? data : this.state.vendors.concat(newVendors);

        this.setState({
          vendors,
          // customers,
          isLoading: false,
          hasMore: newVendors.length >= this.limit,
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        });
      });

    axios
      .get(`${config.apiUrl}/organization/count`, {
        params: commonParams,
      })
      .then(({ data }) => {
        this.setState({
          total: data.total,
        });
      })
      .catch((ex) => {
        console.error("[ERROR - /organization/count]:", ex);
      });
  }

  close() {
    this.setState({
      showDialog: false,
    });
    this.rowSelected = null;
    this.selected = null;
  }

  closeDialog() {
    this.setState({
      showDialogEdit: false,
      isNewVendor: false
    });
    this.rowSelected = null;
  }

  showEdit(e, isNewVendor) {
    this.setState({
      showDialogEdit: true,
      isNewVendor: isNewVendor,
      errors: {},
      editingVendor: {
        _id: e._id || "",
        name: e.name || "",
        address1: e.address1 || "",
        address2: e.address2 || "",
        city: e.city || "",
        contactEmail: e.contactEmail || "",
        phone: e.phone || "",
        state: e.state || "",
        zipcode: e.zipcode || "",
        contactPhone: e.contactPhone || "",
        contactName: e.contactName || ""
      },
    });
  }

  showDelete(e) {

    if (confirm('Do you want delete the vendor ' + `${e.name ? e.name : ""}` + "?")) {
      this.deleteVendor(e);
    }

  }

  deleteVendor(e) {
    this.setState(
      {
        isUpdating: true,
      },
      () => {
        axios
          .post(`${config.apiUrl}/organization/remove`, {
            _id: e._id,
          })
          .then(({ data }) => {
            this.rowSelected = null;
            this.setState({
              showDialogDelete: false,
              showDialog: false,
              vendors: this.state.vendors.filter(
                (cust) => cust._id !== data._id
              ),
              isUpdating: false,
            });
          })
          .catch(() => {
            this.setState({
              showDialogDelete: false,
              showDialog: false,
              isUpdating: false,
            });
          });
      }
    );
  }

  changeFilter(v) {
    this.setState(
      {
        filter: v.key,
        vendors: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }


  changeFilterByZipCodes(items) {
    this.setState(
      {
        vendors: [],
        hasMore: true,
        filterZipCodes: [].concat(items),
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  saveUpdateInfo(data) {

    const hasError = this.handleValidateForm();

    if (!hasError) {

      data.orgType = "vendor";

      let url = `${config.apiUrl}/organization/update`;
      if (this.state.isNewVendor)
        url = `${config.apiUrl}/organization/create`;

      axios
        .post(url, data)
        .then(({ data }) => {
          const isExisted = this.state.vendors.some(
            (item) => item._id === data._id
          );
          this.setState({
            vendors: isExisted
              ? this.state.vendors.map((item) => {
                if (item._id === data._id) {
                  return data;
                }
                return item;
              })
              : this.state.vendors.concat(data),
            showDialogEdit: false,
          });
        })
        .catch((ex) => {
          console.error(ex);
        });
    }
  }

  handleChangeInput(name, value) {
    const newValue =
      (typeof value === "string" && value) ||
      (typeof value === "object" && value.key) ||
      "";

    this.setState(({ errors }) => {
      return {
        [name]: newValue,
        errors: _.omit(errors, [name]),
      };
    });

    this.setState((oldState) => ({
      editingVendor: { ...oldState.editingVendor, [name]: value },
    }));
  }

  handleValidateForm() {
    const {
      name,
      address1,
      address2,
      city,
      state,
      zipcode,
      phone,
      contactName,
      contactPhone,
      contactEmail,
    } = this.state.editingVendor;
    let newErrors = {};

    if (!name) {
      newErrors = {
        ...newErrors,
        name: "Please enter vendor name",
      };
    }
    if (!address1) {
      newErrors = {
        ...newErrors,
        address1: "Please enter 1st address",
      };
    }
    if (!address2) {
      newErrors = {
        ...newErrors,
        address2: "Please enter 2nd address",
      };
    }
    if (!city) {
      newErrors = {
        ...newErrors,
        city: "Please enter city",
      };
    }
    if (!state) {
      newErrors = {
        ...newErrors,
        state: "Please enter state",
      };
    }
    if (!zipcode) {
      newErrors = {
        ...newErrors,
        zipcode: "Please enter zipcode",
      };
    }
    if (!phone) {
      newErrors = {
        ...newErrors,
        phone: "Please enter phone",
      };
    } else if (!helpers.validatePhoneNumber(phone)) {
      newErrors = {
        ...newErrors,
        phone: "Phone is invalid",
      };
    }
    if (!contactName) {
      newErrors = {
        ...newErrors,
        contactName: "Please enter contact name",
      };
    }
    if (!contactPhone) {
      newErrors = {
        ...newErrors,
        contactPhone: "Please enter contact phone",
      };
    } else if (!helpers.validatePhoneNumber(contactPhone)) {
      newErrors = {
        ...newErrors,
        contactPhone: "Contact phone is invalid",
      };
    }
    if (!contactEmail) {
      newErrors = {
        ...newErrors,
        contactEmail: "Please enter contact email",
      };
    } else if (!helpers.validateEmail(contactEmail)) {
      newErrors = {
        ...newErrors,
        contactEmail: "Contact email is invalid",
      };
    }

    if (!_.isEmpty(newErrors)) {
      this.setState({
        errors: newErrors,
      });

      return true;
    }

    return false;
  }


  _onFilterChanged(filterText, list) {
    if (this.state.zipCodes === null) {
      return [];
    }

    const check = {};
    (list || []).forEach((e) => {
      check[e.key] = true;
    });

    const ftext = filterText.trim().toLowerCase();
    const result = [];
    for (let zipcode of this.state.zipCodes) {
      const tag = zipcode;
      if (tag.indexOf(ftext) === 0 && !check[tag]) {
        result.push(tag);
        if (result.length >= 20) break;
      }
    }

    return result.map((e) => ({
      key: e,
      name: e,
    }));
  }


  renderHeaderFilter({ fieldName, name = "" }) {
    let timeout;
    return (
      <TextField
        name={fieldName}
        placeholder={`Find ${name.toLowerCase()}`}
        value={this.state.headerFilters[fieldName]}
        onChanged={(value) => {
          if (timeout) {
            clearTimeout(timeout);
          }
          this.setState(
            {
              headerFilters: {
                ...this.state.headerFilters,
                [fieldName]: value,
              },
            },
            () => {
              timeout = setTimeout(() => {
                this.fetch(this.props.searchBox, 0);
              }, 300);
            }
          );
        }}
      />
    );
  }


  render() {
    let columns = this.state.columns;
    const editingVendor = this.state.editingVendor;
    // render HTML
    columns = columns.map((col) => {
      if (col.key === "registrationConfirmed") {
        col.onRender = (item) =>
          item.key !== "filterRow" && item.registrationConfirmed && (
            item.registrationConfirmed === "true" ? "Verified" : "Unverified"

          );

      } else if (col.key === "editData") {
        col.onRender = (item) =>
          item.key !== "filterRow" && (
            <div>
              <button className="tbl-btn" onClick={() => this.showEdit(item, false)}>
                <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
              </button>
              <button className="tbl-btn" onClick={() => this.showDelete(item)}>
                <i className="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
              </button>
            </div>
          );
      } else if (
        ["name", "address1", "address2", "city", "phone"].includes(col.key)
      ) {
        const oldRender = col.onRender;
        col.onRender = (item) => {
          if (item.key === "filterRow") {
            return this.renderHeaderFilter(col);
          }
          return oldRender ? oldRender(item) : item[col.fieldName];
        };
      }
      return col;
    });

    const {
      isLoading,
      hasMore,
      vendors,
      total,
      filter,
      openHeaderFilters,
      errors
    } = this.state;

    return (
      <div style={{ margin: 10 }}>
        <div style={{
          position: "fixed",
          top: 40,
          left: 0,
          right: 0,
          zIndex: 999,
          background: "white",
          padding: "10px 15px 15px 15px",
        }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {["admin", "manager"].includes(
              this.props.auth.user.accountType
            ) && (
                <PrimaryButton onClick={() => this.showEdit({}, true)}>
                  Add Vendor
                </PrimaryButton>
              )}
          </div>
        </div>
        <div style={{ marginTop: 50 }}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => this.fetch()}
            useWindow={true}
            initialLoad={false}
            style={{ marginBottom: 30 }}
            hasMore={hasMore}
            loader={
              isLoading ? <Spinner key={1} size={SpinnerSize.large} /> : null
            }
          >
            <DetailsList
              items={[
                ...(openHeaderFilters ? [{ key: "filterRow" }] : []),
                ...vendors,
              ]}
              columns={columns}
              layoutMode={DetailsListLayoutMode.justified}
              checkboxVisibility={CheckboxVisibility.hidden}
              style={{ fontSize: 20 }}
              setKey="_id"
              onColumnHeaderClick={() =>
                this.setState({
                  openHeaderFilters: !this.state.openHeaderFilters,
                })
              }
              onRenderRow={(props) => {
                let bg = "";
                if (props.item.key === "filterRow") {
                  bg = "rgba(240, 240, 240, 1)";
                }
                return (
                  <div
                    ref={(e) => (this.rowRefs[props.item._id] = e)}
                    style={{ background: bg }}
                  >
                    <DetailsRow {...props} />
                  </div>
                );
              }}

            />
          </InfiniteScroll>
        </div>
        <StatusBar>
          <span>Total: {total}</span>
          {this.rowSelected && (
            <span>
              {" "}
              | Selected: #{vendors.indexOf(this.rowSelected) + 1} -{" "}
              {`${this.rowSelected.firstName} ${this.rowSelected.lastName}`}{" "}
            </span>
          )}
        </StatusBar>

        <Dialog
          isOpen={this.state.showDialogDelete}
          title="Are you sure you want delete this vendor?"
          isBlocking={false}
          closeButtonAriaLabel="Close"
        >
          <DialogFooter>
            {this.state.isUpdating ? (
              <Spinner key={1} size={SpinnerSize.large} />
            ) : (
              [
                <PrimaryButton key="del" onClick={() => this.deleteVendor()}>
                  Delete
                </PrimaryButton>,
                <DefaultButton
                  key="cancel"
                  onClick={() => this.setState({ showDialogDelete: false })}
                >
                  Cancel
                </DefaultButton>,
              ]
            )}
          </DialogFooter>
        </Dialog>

        <Dialog
          isOpen={this.state.showDialogEdit}
          type={DialogType.normal}
          onDismiss={() => this.closeDialog()}
          title={this.state.isNewVendor ? "New Vendor" : (`EDIT | ${editingVendor && editingVendor.name} | ${editingVendor && editingVendor.phone}`)}
          isBlocking={true}
          containerClassName="relative-info"
        >
          {editingVendor && (
            <div className="ms-Grid">

              <TextField
                className="one-line-150"
                label="Vendor name"
                placeholder="Enter name"
                value={editingVendor.name}
                onChanged={(value) => this.handleChangeInput("name", value)}
                errorMessage={errors.name}
              />
              <TextField
                className="one-line-150"
                label="Address 1"
                placeholder="Enter 1st address"
                value={editingVendor.address1}
                onChanged={(value) => this.handleChangeInput("address1", value)}
                errorMessage={errors.address1}
              />
              <TextField
                className="one-line-150"
                label="Address 2"
                placeholder="Enter 2nd address"
                value={editingVendor.address2}
                onChanged={(value) => this.handleChangeInput("address2", value)}
                errorMessage={errors.address2}
              />
              <TextField
                className="one-line-150"
                label="City"
                placeholder="Enter city"
                value={editingVendor.city}
                onChanged={(value) => this.handleChangeInput("city", value)}
                errorMessage={errors.city}
              />
              <TextField
                className="one-line-150"
                label="State"
                placeholder="Enter state"
                value={editingVendor.state}
                onChanged={(value) => this.handleChangeInput("state", value)}
                errorMessage={errors.state}
              />
              <TextField
                className="one-line-150"
                label="Zipcode"
                placeholder="Enter zipcode"
                value={editingVendor.zipcode}
                onChanged={(value) => this.handleChangeInput("zipcode", value)}
                errorMessage={errors.zipcode}
              />
              <TextField
                className="one-line-150"
                label="Phone"
                placeholder="Enter phone number"
                value={editingVendor.phone}
                onChanged={(value) => this.handleChangeInput("phone", value)}
                errorMessage={errors.phone}
              />
              <TextField
                className="one-line-150"
                label="Contact name"
                placeholder="Enter contact's name"
                value={editingVendor.contactName}
                onChanged={(value) => this.handleChangeInput("contactName", value)}
                errorMessage={errors.contactName}
              />
              <TextField
                className="one-line-150"
                label="Contact phone"
                placeholder="Enter contact's phone number"
                value={editingVendor.contactPhone}
                onChanged={(value) => this.handleChangeInput("contactPhone", value)}
                errorMessage={errors.contactPhone}
              />
              <TextField
                className="one-line-150"
                label="Contact email address"
                placeholder="Enter contact's email"
                value={editingVendor.contactEmail}
                onChanged={(value) => this.handleChangeInput("contactEmail", value)}
                errorMessage={errors.contactEmail}
                readOnly={!this.state.isNewVendor}
              />

            </div>
          )}

          <DialogFooter>
            <PrimaryButton onClick={() => this.saveUpdateInfo(editingVendor)}>
              Save
            </PrimaryButton>
            <DefaultButton onClick={() => this.closeDialog()}>
              Cancel
            </DefaultButton>
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(Vendor);



// WEBPACK FOOTER //
// ./client/components/Vendor.js